import { ReactComponent as GifEmptyStateIllustration } from 'Assets/icons/gif-empty-state.svg';
import React from 'react';
import { GifEmptyStateProps } from './index.types';

export const GifEmptyState = ({
  title,
  description,
  'data-testid': testId,
}: GifEmptyStateProps): React. ReactElement => (
  <div
    className="flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto scroll-area-content px-4 py-4 text-center font-sans"
    data-testid={testId}
  >
    <div className="m-auto flex flex-col items-center">
      <GifEmptyStateIllustration
        aria-hidden
        className="mb-6 block h-[113.5px] w-[156px] max-w-full shrink-0 object-contain"
      />

      <p className="text-[12px] font-semibold leading-normal text-foreground">
        {title}
      </p>

      <p className="mt-2 max-w-full text-[12px] font-normal leading-normal text-foreground">
        {description}
      </p>
    </div>
  </div>
);
